<app-layout [domain]="(domain$ | async)" [theme]="(theme$ | async)"></app-layout>